if (!customElements.get('quick-shop-radio')) {
  class QuickShopRadio extends HTMLElement {
    constructor() {
      super();

      this.quickShopOptions = document.querySelectorAll('[data-quick-shop-option]');

      this?.querySelectorAll('[data-quick-shop-option]').forEach((option, index) => {
        if (index === 0) {
          option
            .closest('.quick-shop__option')
            .querySelector('.option__label_shop')
            .classList.add('option__label_shop--checked');
        }
      });

      // Bind option select events
      this?.querySelectorAll('[data-quick-shop-option]').forEach((option) => {
        option.addEventListener('click', () => {
          const label = option
            ?.closest('.quick-shop__option')
            ?.querySelector('.option__label_shop');
          this.updateLabelState(label, option);
        });
      });

      // Bind "Add to cart" button click event
      const addToCartButton = this.querySelector('[data-add-to-cart-button]');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
          const selectedOption =
            this.closest('.quick-shop').querySelector('.option__input--checked');
          if (selectedOption) {
            const notification = this.closest('.quick-shop').querySelector(
              '.quick-shop__notification'
            );

            notification.classList.remove('opacity-0');
            notification.classList.add('opacity-100');

            setTimeout(() => {
              notification.classList.remove('opacity-100');
              notification.classList.add('opacity-0');
            }, 3000);

            this.onOptionSelect(selectedOption.value, selectedOption.dataset.inventoryQuantity);
          } else {
            console.error('No variant selected.');
          }
        });
      }
    }

    updateLabelState(label, input) {
      this.quickShopOptions.forEach((option) => {
        const label = option?.closest('.quick-shop__option')?.querySelector('.option__label_shop');
        const input = option?.closest('.quick-shop__option')?.querySelector('.option__input');
        label?.classList.remove('option__label_shop--checked');
        input?.classList.remove('option__input--checked');
      });
      label?.classList.add('option__label_shop--checked');
      input?.classList.add('option__input--checked');
    }

    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
    }
  }

  window.QuickShopRadio = QuickShopRadio;
  customElements.define('quick-shop-radio', QuickShopRadio);
}
